import { render, staticRenderFns } from "./MobileSafetyDailyCheckList.vue?vue&type=template&id=f8fb03e4&scoped=true&"
import script from "./MobileSafetyDailyCheckList.vue?vue&type=script&lang=js&"
export * from "./MobileSafetyDailyCheckList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fb03e4",
  null
  
)

export default component.exports